import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { PHONE_TEMPLE_BASE_URL, PHONE_TEMPLE_BASE_URL_API } from "../../config";

const baseQuery = fetchBaseQuery({
  baseUrl: PHONE_TEMPLE_BASE_URL_API,
  prepareHeaders: (headers, { getState }) => {
    const auth = getState().auth;
    const token = auth?.token;
    const authBearer = auth?.authBearer;
    if (token && authBearer) {
      headers.set("Authorization", `Bearer ${authBearer}`);
      headers.set("Access-Control-Allow-Credentials", "true");
      headers.set("Access-Control-Allow-Origin", `${PHONE_TEMPLE_BASE_URL}`);
      headers.set("Token", `${token}`);
      return headers;
    }
  },
});

const baseQueryWithSessionCheck = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);
  if (result?.error?.status === 401) {
    window.location.replace(result?.error?.data.url);
  }
  return result;
};

const apiSlice = createApi({
  reducerPath: "apiSlice",
  baseQuery: baseQueryWithSessionCheck,
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({}),
});

export default apiSlice;
